<template>
  <div class="scroll">
    <messaging-bar :noBorder="true" class="topbar message-bar">
      <div class="info">
        <div class="user-image">
          <img src="@/assets/lever.png" class="is-40x40 margin-zero" width="70" height="70" alt="">
        </div>
        <div class="text-info">
          <a><strong>Lever</strong></a>
          <span v-if="leverAuth">Fill in the fields below to enable integration between HireVibes & Lever</span>
          <span v-else>Before connecting your Lever account to HireVibes you must first authorize the integration. Once authorized, please choose your company again to connect</span>
        </div>
      </div>
    </messaging-bar>
    <div v-if="leverAuth" class="px-20">
      <div class="control is-flex field align-center">
        <toggle v-model="autoPost" :isEditable="true"></toggle> <label class="ml-10">Automatically post jobs from Lever to HireVibes</label>
      </div>
      <div class="control is-flex field align-center">
        <toggle v-model="autoApplicants" :isEditable="true"></toggle> <label class="ml-10">Automatically send applicants from Lever to HireVibes</label>
      </div>
      <div  class="field">
        <field label="Choose User">
          <div class="control is-expanded is-fullwidth">
            <div class="select is-fullwidth">
              <select v-model="user">
                <option value="">Choose User</option>
                <option v-for="leverUser in leverUsers" :key="leverUser.id" :value="leverUser.id">
                  {{ leverUser.name }}
                </option>
              </select>
            </div>
          </div>
        </field>
      </div>
      <div class="field">
        <field label="Default Job type">
          <div class="control is-expanded is-fullwidth">
            <div class="select is-fullwidth">
              <select v-model="type">
                <option value="">Choose Job Type</option>
                <option v-for="jt in jobTypes" :key="jt.id" :value="jt.id">
                  {{ jt.name }}
                </option>
              </select>
            </div>
          </div>
        </field>
      </div>
      <div v-if="!leverConnected">
        <button :disabled="loading" class="button is-primary is-fullwidth" @click="saveHandler"><spinner size="small" v-if="loading" ></spinner><p v-else>SAVE</p></button>
      </div>
      <hr>
      <div class="field mt-20">
        <text-field label="Webook URL" v-model="webhookUrl" readonly />
      </div>

    </div>
    <div v-else class="px-20">
      <button @click="authLever" class="button is-primary">Authorize Lever</button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import Spinner from 'vue-simple-spinner'
import UserImage from '@/components/general/user-image'
import MessagingBar from '@/components/messaging/messaging-bar'
import Field from '@/components/general/field'
import Toggle from '@/components/toggle'
import TextField from '@/components/general/text-field'
import {getLeverRedirectUri} from '../../helpers/auth'

export default {
  name: 'GreenHouseForm',
  components: {
    UserImage,
    MessagingBar,
    Field,
    Toggle,
    TextField,
    Spinner
  },
  props: {
    toggleGreenHouseModal: {
      type: Function
    },
    companies: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions('lever', ['attachLever']),
    ...mapMutations('lever', [ 'setAutoPost', 'setAutoApplicants',
      'setAuthUsername', 'setAuthPassword', 'setType', 'setCompanyId', 'setUser']),
    validations () {
      return true
    },
    saveHandler () {
      const validations = this.validations()
      if (!validations) {
        return false
      }
      console.log(this.formType)
      this.attachLever()
    },
    authLever () {
      window.location.href = getLeverRedirectUri()
    }
  },
  computed: {
    ...mapState('domain', ['jobTypes']),
    ...mapState('users', ['user']),
    ...mapState('lever', {
      formAutoPost: 'autoPost',
      formAutoApplicants: 'autoApplicants',
      formWebhookUrl: 'webhookUrl',
      formAuthUsername: 'authUsername',
      formAuthPassword: 'authPassword',
      formType: 'type',
      loading: 'loading',
      leverConnected: 'leverConnected',
      formCompanyId: 'companyId',
      leverAuth: 'leverAuth',
      leverUsers: 'leverUsers',
      leverUser: 'user'
    }),
    autoPost: {
      get () { return this.formAutoPost },
      set (value) { this.setAutoPost(value) }
    },
    autoApplicants: {
      get () { return this.formAutoApplicants },
      set (value) { this.setAutoApplicants(value) }
    },
    webhookUrl: {
      get () { return this.formWebhookUrl },
      set (value) { }
    },
    authUsername: {
      get () { return this.formAuthUsername },
      set (value) { }
    },
    authPassword: {
      get () { return this.formAuthPassword },
      set (value) { }
    },
    type: {
      get () { return this.formType },
      set (value) { this.setType(value) }
    },
    user: {
      get () { return this.leverUser },
      set (value) { this.setUser(value) }
    }
  }

}
</script>

<style scoped lang="scss">
@import '~@/styles/defaults.scss';
.info {
  display: flex;
  flex-direction: row;
}
.text-info {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-bottom: 10px;
  span {
    color: #888;
  }
}
.message-bar{
  height: auto !important; min-height: auto !important;
}

.topbar {
  display: flex;
  a {
    color: black;
  }
}

.mt-20{
  margin-top: 20px;
}

.px-20{
  padding: 20px
}
.ml-10{
  margin-left: 20px
}
.align-center{
  align-items: center;
}
.scroll{
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/lever-form.vue